import React, { Component } from 'react';
import PhotoThumb from '../PhotoThumb';

export default class NoteActivity extends Component {
  render() {
    const { activity } = this.props;
    return (
      <div className="activity__note">
        <div className="activity__paragraph">{activity.data.desc}</div>
        <PhotoThumb photoUrl={activity.photo_url} />
      </div>
    );
  }
}
